module.exports = __webpack_public_path__ + "media/images/icon_a8-f7815b34d1fa18d1f476b5be802b12cc.png";